import { useAsync } from '../../../utils/useAsync';
import { ConfigControllerProps } from './interfaces';
import { usePlacesSearchService } from '../../../services/placesService/placesService';
import { useBikletaPointsService } from '../../../services/bikletaPoints/bikletaPointsService';
import { useState } from 'react';
import { useStore } from '../../../utils/useStore';

export const useCommerceProfileViewController = (): ConfigControllerProps => {
  const service = usePlacesSearchService();
  const bpService = useBikletaPointsService();
  const [isLoading, setIsLoading] = useState(false);
  const { updateBikletaPoint } = useStore();
  const [resultsData, , loadingResults, executeSearch, ,] = useAsync(
    service.fetchResults,
    null
  );

  const getInfoFromPhoneNumber = number => {
    const sections = number.split(' ');
    if (sections.length === 1) {
      return {
        phoneNumber: sections[0],
      };
    }
    return {
      region: sections[0],
      phoneNumber: sections.slice(1, sections.length).join(''),
    };
  };

  const submitEditedData = async (id: string, data: any) => {
    try {
      const { type, point, web, instagram, facebook, tiktok, googleBusiness } =
        data;

      const mappedData = {
        ...data,
        types: type,
        location: {
          type: 'Point',
          coordinates: [point.lng, point.lat],
        },
        socials: {
          web,
          instagram,
          facebook,
          tiktok,
          googleBusiness,
        },
      };

      const { data: updatedBkPoint } = await bpService.editPointData(
        id,
        mappedData
      );

      updateBikletaPoint(updatedBkPoint);
    } catch (error) {
      console.error('Error edit: ', error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    setSearchQuery: executeSearch,
    loadingData: loadingResults,
    placesSearchResults: resultsData?.data.results,
    getInfoFromPhoneNumber,
    submitEditedData,
    isSubmitting: isLoading,
  };
};
